import {
  ADD_NEW_USER_ONBOARDING,
  SET_NEW_USER_ONBOARDING,
  SET_SAVED_SEARCHES,
} from '../actionTypes'

const initialState = {
  step: 0,
  savedSearches: [],
}

const reducer = (state = initialState, { type, step, savedSearches }) => {
  switch (type) {
    case ADD_NEW_USER_ONBOARDING:
      return { ...state, step: state.step + step }
    case SET_NEW_USER_ONBOARDING:
      return { ...state, step }
    case SET_SAVED_SEARCHES:
      return { ...state, savedSearches }
    default:
      return state
  }
}

export default reducer
export { initialState }
